/**
 * Every word the member detail pane says, in one place (ISSUE-194).
 *
 * Plain, warm, direct American English. No jargon, no dashes.
 */

export const AWARDS_SECTION_TITLE = "Medals and trophies";
export const CONTESTS_SECTION_TITLE = "Playing in";

export const SCOPE_TABS_LABEL = "Choose a time range";
export const SCOPE_THIS_SEASON_LABEL = "This season";
export const SCOPE_ALL_TIME_LABEL = "All time";

export const AWARDS_UNAVAILABLE_LINE =
  "We could not load the awards right now.";

export const CONTESTS_EMPTY_LINE = "Not in any contest in this pool yet.";

export const PLAYING_NOW_LABEL = "Playing now";
export const MANAGE_ACTION_LABEL = "Manage member";
export const BACK_ACTION_LABEL = "Back to members";

export const MEMBER_MISSING_TITLE = "We could not find that member";
export const MEMBER_MISSING_BODY =
  "Go back and pick them from the members list.";
export const MEMBER_NO_IDS_LINE = "Go back and pick a member to see.";
